// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { createWidgetizedSplitPanel } from './implementation';

export const SplitPanelInternal = createWidgetizedSplitPanel();
